import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiKey } from "../config/config";
import { useNavigate, useParams } from "react-router-dom";
import Table from "../components/Table";
import { convertDateFormat } from "../services/helper";

function CustomerContracts({ lang }) {
  const { id } = useParams();

  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;
  const branchId = JSON.parse(
    JSON.parse(sessionStorage.getItem("aman-admin"))?.admin
  )?.branch_id;

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const columns = [
    {
      header: lang["Contract No"] || "Contract No",
      accessorKey: "id",
      cell: (row) => row.getValue() * 9999,
    },
    {
      header: lang["Customer_Name"] || "Customer Name",
      accessorKey: "customer_name",
    },
    {
      header: lang["Mobile_Number"] || "Mobile Number",
      accessorKey: "customer_mobile",
    },
    {
      header: lang.Amount || "Amount",
      accessorKey: "final_installment",
    },
    {
      header: lang.Date_Contract || "Date Contract",
      accessorKey: "date_contract",
      cell: (row) => convertDateFormat(row.getValue()),
    },
    {
      header: lang.Note || "Note",
      accessorKey: "customer_note",
      cell: (row) => (row.row.original.status !== 2 ? row.getValue() : ""),
    },
    {
      header: lang.Status || "Status",
      accessorKey: "status",
      cell: (row) => {
        const status = row.getValue();
        return parseInt(status) === 1 ? (
          <span className="badge rounded-pill bg-success">
            {lang.active || "Active"}
          </span>
        ) : parseInt(status) === 2 ? (
          <span className="badge rounded-pill bg-primary">
            {lang.completed || "Completed"}
          </span>
        ) : parseInt(status) === 3 ? (
          <span className="badge rounded-pill bg-danger">
            {lang.defaulted || "Defaulted"}
          </span>
        ) : (
          <span className="badge rounded-pill bg-warning">
            {lang.no_contract || "No Contract"}
          </span>
        );
      },
    },
    {
      header: lang.Actions || "Actions",
      cell: (row) => (
        <button
          onClick={() =>
            navigate(`../customer/contract-information/${row.row.original.id}`)
          }
          className="btn btn-primary"
        >
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-eye-icon lucide-eye"
            >
              <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </span>
        </button>
      ),
    },
  ];

  useEffect(() => {
    axios
      .get(`${apiKey}/get-contracts-customer`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          branch_id: branchId,
          customer_id: id,
        },
      })
      .then((res) => {
        setData(res.data.result);
      })
      .catch((err) => {
        console.log(err.response.data.message);
      });
  }, [branchId, id, token]);

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>{lang.Customer_Management || "Customer Management"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item">
              {lang.Customer_Management || "Customer Management"}
            </li>
            <li className="breadcrumb-item">
              {lang.Customer_List || "Customer List"}
            </li>
            <li className="breadcrumb-item active">
              {lang.Contracts || "Contracts"}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="row pt-3">
                <div className="rr col-9">{lang.Contracts || "Contracts"}</div>
              </div>
              <div className="card-body">
                <div classNames="d-flex mt-3 mb-3">
                  <Table lang={lang} data={data} columns={columns} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default CustomerContracts;
